
const initialState = {
    organizationStatsResponse: null,
    organizationList: null,
    usersList: null,
    userListByOrganization: null,
    assignedUserListByOrganization: null,
    addOrganizationResponse: null,
    organizationDetail: null,
    domainList: null,
    domainListByOrganization: null,
    assignedDomainListByOrganization: null,
    updateOrganizationResponse: null,
    deleteOrganizationResponse: null,
    addDomainResponse: null,
    assignUnAssignResponse: null
}

export default function organizationReducer(state=initialState, action) {
    switch(action.type) {
        case 'ORGANIZATION_STATS_SUCCESS':
            return {
                ...state,
                organizationStatsResponse: action.payload
            }
        case 'ORGANIZATION_LIST_SUCCESS' :
            return {
                ...state,
                organizationList: action.payload
            }
        case 'USERS_LIST_SUCCESS' :
            return {
                ...state,
                usersList: action.payload
            }
        case 'USERS_LIST_BY_ORGANIZATION_SUCCESS' :
            return {
                ...state,
                userListByOrganization: action.payload
            }
        case 'ASSIGNED_USERS_LIST_BY_ORGANIZATION_SUCCESS' :
            return {
                ...state,
                assignedUserListByOrganization: action.payload
            }
        case 'ADD_ORGANIZATION_SUCCESS' :
            return {
                ...state,
                addOrganizationResponse: action.payload
            }
        case 'RESET_ADD_ORGANIZATION_RESPNSE' :
            return {
                ...state,
                addOrganizationResponse: null
            }
        case 'ORGANIZATION_DETAILS_SUCCESS' :
            return {
                ...state,
                organizationDetail: action.payload
            }
        case 'DOMAIN_LIST_SUCCESS' : 
            return {
                ...state,
                domainList: action.payload
            }
        case 'RESET_DOMAIN_LIST_RESPONSE':
            return {
                ...state,
                domainList: null
            }
        case 'DOMAIN_LIST_BY_ORGANIZATION_SUCCESS' :
            return {
                ...state,
                domainListByOrganization: action.payload
            }
        case 'MODIFY_DOMAIN_LIST_BY_ORGANIZATION_SUCCESS' :
            return {
                ...state,
                assignedDomainListByOrganization: action.payload
            }
        case 'RESET_ORGANIZATION_DETAILS' :
            return {
                ...state,
                organizationDetail: null
            }
        case 'UPDATE_ORGANIZATION_SUCCESS' :
            return {
                ...state,
                updateOrganizationResponse: action.payload
            }
        case 'RESET_UPDATE_ORGANIZATION_RESPONSE':
            return {
                ...state,
                updateOrganizationResponse: null
            }
        case 'RESET_UPDATE_ORGANIZATION_DETAIL' :
            return {
                ...state,
                updateOrganizationResponse: null
            }
        case 'DELETE_ORGANIZATION_SUCCESS' :
            return {
                ...state,
                deleteOrganizationResponse: action.payload
            }
        case 'RESET_DELETE_ORGANIZATION_RESPONSE':
            return {
                ...state,
                deleteOrganizationResponse: null
            }
        case 'RESET_ORGANIZATION_LIST' : 
            return {
                ...state,
                organizationList: null
            }
        case 'ADD_DOMAIN_SUCCESS':
            return {
                ...state,
                addDomainResponse: action.payload
            }
        case 'RESET_ADD_DOMAIN_RESPONSE': 
            return {
                ...state,
                addDomainResponse: null
            }
        case 'ASSIGN_UNASSIGN_SUCCESS' :
            return {
                ...state,
                assignUnAssignResponse: action.payload
            }
        case 'RESET_DOMAIN_LIST' :
            return {
                ...state,
                domainListByOrganization: null
            }
        case 'RESET_USERS_LIST':
            return {
                ...state,
                usersList: null
            }
        case 'RESET_ASSIGN_UNASSIGN_RESPONSE': 
            return {
                ...state,
                assignUnAssignResponse: null
            } 
        default:
            return state;
    }
}